import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));
const KorporasiContainer = dynamic(() => import('src/containers/Korporasi'));

const Korporasi = () => {
	return (
		<>
			<HeadC
				title="Kerja Sama dan Mitra Korporasi di KlikDokter"
				description={
					'Mari bekerja sama dan menjadi Mitra Korporasi di KlikDokter. ' +
					'Ajukan kerja sama produk, kerja sama artikel, hingga iklan berbayar di sini.'
				}
			/>
			<KorporasiContainer />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	return {
		props: {
			pageHeaderContent: {
				breadcrumbs: [{ label: 'Korporasi' }],
			},
		},
	};
});

export default Korporasi;
